"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || (function () {
    var ownKeys = function(o) {
        ownKeys = Object.getOwnPropertyNames || function (o) {
            var ar = [];
            for (var k in o) if (Object.prototype.hasOwnProperty.call(o, k)) ar[ar.length] = k;
            return ar;
        };
        return ownKeys(o);
    };
    return function (mod) {
        if (mod && mod.__esModule) return mod;
        var result = {};
        if (mod != null) for (var k = ownKeys(mod), i = 0; i < k.length; i++) if (k[i] !== "default") __createBinding(result, mod, k[i]);
        __setModuleDefault(result, mod);
        return result;
    };
})();
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const InputText_1 = __importDefault(require("@Components/Fields/InputText"));
const Dropdown_1 = __importDefault(require("@Components/Selectors/Dropdown"));
const RoleTooltip_1 = __importDefault(require("@Components/WorkRegistrationSubs/AddWriter/WriterCreateForm/RoleTooltip"));
const Button_1 = require("@Components/Buttons/Button");
const react_1 = __importStar(require("react"));
const contexts_1 = require("@App/contexts");
const WriterCreateSubForm = ({ firstName, lastName, roleCode, ipiNumber, validations, onClick, buttonsDisabled, getValues, }) => {
    const { libStore } = (0, react_1.useContext)(contexts_1.StoresContext);
    return (react_1.default.createElement("div", { className: "writer-sub-form-component" },
        react_1.default.createElement(InputText_1.default, { mainColor: true, id: 'firstName', label: 'Writer First Name', value: firstName, errorMessage: validations.firstName.error, required: validations.firstName.required, onChange: getValues }),
        react_1.default.createElement(InputText_1.default, { mainColor: true, id: 'lastName', label: 'Writer Last Name', value: lastName, errorMessage: validations.lastName.error, required: validations.lastName.required, onChange: getValues }),
        react_1.default.createElement(Dropdown_1.default, { options: libStore.writerRoles, label: 'Writer Role', mainColor: true, selectedValue: roleCode ? libStore.writerRoles.find((option) => +option.id === roleCode) : null, onSelect: (option) => getValues(+option.id, 'roleCode'), isSearchable: true, required: true, errorMessage: roleCode ? undefined : 'Required', tooltip: react_1.default.createElement(RoleTooltip_1.default, null) }),
        !roleCode && (react_1.default.createElement("div", { className: 'writer-role-error-help' },
            "Click",
            ' ',
            react_1.default.createElement("a", { href: "https://help.themlc.com/en/support/writer-roles", target: "_blank", rel: "noopener noreferrer" }, "here"),
            ' ',
            "for a list of writer roles and their definitions.")),
        react_1.default.createElement(InputText_1.default, { mainColor: true, id: 'ipiNumber', label: 'IPI', value: ipiNumber, errorMessage: validations.ipiNumber.error, required: validations.ipiNumber.required, onChange: getValues }),
        react_1.default.createElement("div", { className: 'writer-sub-form-footer' },
            react_1.default.createElement(Button_1.Button, { mainColor: true, type: 'secondary', onClick: () => onClick(false), disabled: buttonsDisabled }, "Save & Add Another Writer"),
            react_1.default.createElement(Button_1.Button, { mainColor: true, type: 'primary', onClick: () => onClick(true), disabled: buttonsDisabled }, "Continue"))));
};
exports.default = WriterCreateSubForm;
